import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthStateService } from '../services/auth-state.service';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const companyHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthStateService);
  const router = inject(Router);

  const token = authService.getToken();

  let headers = req.headers.set('x-company-id', environment.companyId);

  if (req.url.startsWith(environment.videoMeetUrl)) {
    headers = headers.set('videoenv', environment.production ? 'prod' : 'dev');
  }

  if (token) {
    headers = headers.set('x-access-token', token);
  }

  const modifiedReq = req.clone({ headers });

  // 3. Catch backend auth errors globally
  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check for Unauthorized (401) or Forbidden (403)
      if (error.status === 401) {
        console.error('Session expired. Redirecting to login...');

        authService.clearSession();

        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
